import { v4 as generateID } from '@lukeed/uuid';
import { addIDs } from '../assignment/utils/generalAssignment/checkIDs';
import { detectSignals } from '../peaks/peaksToRanges';
import { solventSuppression } from '../peaks/solventSuppression';
import { cloneArray } from '../utilities/clone';
export function markSolventPeaks(input, solventSignals, options = {}) {
    const { frequency = 400 } = options;
    const ranges = addIDs(cloneArray(input));
    const peakList = [];
    for (const range of ranges) {
        const rangeID = range.id;
        for (const signal of range.signals || []) {
            const signalID = signal.id;
            for (const peak of signal.peaks || []) {
                peakList.push({
                    ...peak,
                    rangeID,
                    signalID,
                });
            }
        }
    }
    const peaks = solventSuppression(peakList, solventSignals, {
        markSolventPeaks: true,
    });
    const signalsWithSolvent = getSignalIDsWithSolvent(peaks);
    for (const range of ranges) {
        if (!range.signals)
            continue;
        for (const signal of range.signals) {
            if (!signalsWithSolvent.includes(signal.id))
                continue;
            const signalPeaks = [];
            const solventSignalPeaks = [];
            for (const peak of peaks) {
                if (peak.signalID === signal.id) {
                    const { signalID, rangeID, ...newPeak } = peak;
                    if (peak.kind === 'solvent') {
                        solventSignalPeaks.push(newPeak);
                    }
                    else {
                        signalPeaks.push(newPeak);
                    }
                }
            }
            const newSignals = signalPeaks.length > 0
                ? detectSignals({ x: [], y: [] }, signalPeaks, {
                    integralType: 'peak',
                    frequency,
                })
                : [];
            solventSignalPeaks.sort((a, b) => a.x - b.x);
            const lowPPMValue = solventSignalPeaks[0].x;
            const highPPMValue = solventSignalPeaks[solventSignalPeaks.length - 1].x;
            const newSolventSignals = detectSignals({ x: [], y: [] }, solventSignalPeaks, {
                integralType: 'peak',
                frequencyCluster: (highPPMValue - lowPPMValue) * frequency,
                frequency,
            });
            range.signals = [
                ...adaptSignals(newSignals),
                ...adaptSignals(newSolventSignals),
                ...range.signals.filter((currSignal) => currSignal.id !== signal.id),
            ];
        }
    }
    return ranges;
}
function getSignalIDsWithSolvent(solventPeaks) {
    const uniqueSignalID = new Set();
    for (const peak of solventPeaks) {
        if (peak.kind !== 'solvent')
            continue;
        uniqueSignalID.add(peak.signalID);
    }
    return Array.from(uniqueSignalID);
}
function adaptSignals(signals) {
    const newSignals = [];
    for (const signal of signals) {
        const signalResult = {
            id: generateID(),
            delta: signal.delta,
            kind: signal.kind || 'signal',
            multiplicity: signal.multiplicity,
            integration: signal.integralData.value,
        };
        signalResult.peaks = signal.peaks.map((peak) => {
            const newResult = {
                y: peak.intensity,
                ...peak,
            };
            delete newResult.intensity;
            return newResult;
        });
        signalResult.js = signal.nmrJs || [];
        newSignals.push(signalResult);
    }
    return newSignals;
}
//# sourceMappingURL=markSolventSignal.js.map